import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Box } from "@mui/material";
import { useDispatch } from 'react-redux';
import { Popconfirm, Tooltip } from "antd";
import { isEmpty } from "lodash";

import linkIcon from "../../assets/images/newImages/icon-link.svg";
import EditIcon from '../../assets/images/edit-icon.svg';
import { UnLinkItem, removeMappedItem, CheckWorkOrderLinkStatus } from '../../slices/3-layer-products';
import EditProductQtyModal from './EditProductQtyModal';

const SkuRowDetails = (props) => {
  const dispatch = useDispatch();

  const { setShowMappingAlert, data } = props || {};
  const { products_v2, id: sku_id, item_name, sku, vendorasin, image_url } = data || {};

  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);

  const handleUnLinkProduct = (product_id) => {
    dispatch(UnLinkItem({
      sku_id,
      product_id
    })).then(({ payload }) => {
      if (payload?.success) {
        dispatch(removeMappedItem({ field: 'skus', parentId: sku_id, key: 'products_v2', childId: product_id }));
        // props?.expandRow(sku_id);
        props?.handleRefreshPageData(sku_id);
      }
      else if (!isEmpty(payload?.errorData)) handleShowMappingAlert();
    });
  };

  const columnDefs = [
    {
      headerName: 'Mapped Product/Identifier',
      filter: true,
      minWidth: 135,
      flex: 1,
      resizable: true,
      field: "identifier_value",
      cellRenderer: ({ data }) => <span>{`${data?.identifier_value}/${data?.identifier_type?.toUpperCase()}`}</span>
    },
    {
      headerName: 'Product Name',
      filter: true,
      minWidth: 125,
      flex: 1,
      resizable: true,
      field: "name",
      cellRenderer: ({ data }) => (
        <Tooltip placement="bottom" title={data?.name || 'N/A'}>
          <span className="product-name">{data?.name || 'N/A'}</span>
        </Tooltip>
      )
    },
    {
      headerName: 'Brand',
      filter: true,
      minWidth: 120,
      flex: 1,
      resizable: true,
      field: "brand",
      cellRenderer: ({ data }) => <span>{`${data?.brand || 'N/A'}`}</span>
    },
    {
      headerName: 'Packed Quantity',
      minWidth: 120,
      flex: 1,
      resizable: true,
      field: "product_sku_mappings_v2.bundle_quantity"
    },
    {
      headerName: 'Warehouse Stock',
      minWidth: 100,
      flex: 1,
      resizable: true,
      field: 'warehouse_stock',
      cellRenderer: ({ value }) => value || 0
    },
    // {
    //   headerName: 'WH Reserved Stock',
    //   minWidth: 100,
    //   flex: 1,
    //   resizable: true,
    //   field: 'reserved_qty',
    //   cellRenderer: ({ value }) => value || 0
    // },
    {
      headerName: 'COGS',
      minWidth: 130,
      flex: 1,
      resizable: true,
      field: 'product_cogs',
      cellRenderer: ({ value }) => {
        if (value == null || value === '' || value === 0) return '-';
        const num = Number(value);
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
      }
    },
    {
      headerName: 'Total Value',
      minWidth: 120,
      flex: 1,
      resizable: true,
      valueGetter: ({ data }) => {
        const totalValue = (Number(data?.warehouse_stock) + Number(data?.reserved_qty)) * Number(data?.product_cogs);
        return totalValue ? totalValue.toFixed(1) : null;
      },
      field: 'total_value',
      cellRenderer: ({ value }) => value ? `$${value}` : '-'
    },
    {
      headerName: 'Action',
      width: 100,
      resizable: true,
      cellRenderer: ({ data, node }) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <img src={EditIcon} alt='edit' className='cursor-pointer'
              onClick={() => {
                dispatch(CheckWorkOrderLinkStatus({
                  id: data?.id,
                  idType: 'product'
                }))
                  .then(({ payload }) => {
                    if (payload?.success) {
                      setRowIndex(node.rowIndex);
                      setShowEditProductModal(true);
                    }
                    else setShowMappingAlert(true);
                  })
              }}
            />
            <Popconfirm
              placement="left"
              title="Are you sure you want to unlink?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleUnLinkProduct(data?.id)}
            >
              <img src={linkIcon} alt='link' className='cursor-pointer' />
            </Popconfirm>
          </div>
        );
      }
    }
  ];

  const handleShowMappingAlert = () => {
    setShowEditProductModal(false);
    setShowMappingAlert(true);
  };

  return (
    <Box sx={{ maxHeight: 330, overflow: 'auto' }}>
      <AgGridReact
        rowData={products_v2}
        rowHeight={48}
        enableCellTextSelection={true}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        className="sku-details-table"
      />
      {showEditProductModal && <EditProductQtyModal
        open={showEditProductModal}
        onHide={() => setShowEditProductModal(false)}
        skuData={{
          id: sku_id,
          image_url,
          item_name,
          sku,
          asin: vendorasin?.asin
        }}
        productIndex={rowIndex}
        products={products_v2}
        expandRow={props?.expandRow}
        handleRefreshPageData={props?.handleRefreshPageData}
        handleShowMappingAlert={handleShowMappingAlert}
      />}
    </Box>
  );
};

export default SkuRowDetails;
